import { isAllSelected } from './is-all-selected.js';

type Option = Readonly<{ value: string; disabled?: boolean }>;

/** The picks after Select All: every listed option, or none of them once all are, leaving disabled options and picks outside `options` as they were. */
export function toggleSelectAll(
  options: ReadonlyArray<Option>,
  selected: ReadonlyArray<string>,
): string[] {
  const disabledValues = new Set(
    options.filter((option) => option.disabled === true).map((option) => option.value),
  );
  if (isAllSelected(options, selected)) {
    const listedValues = new Set(options.map((option) => option.value));
    return selected.filter((value) => disabledValues.has(value) || !listedValues.has(value));
  }
  const selectedSet = new Set(selected);
  const rest = options
    .filter((option) => option.disabled !== true && !selectedSet.has(option.value))
    .map((option) => option.value);
  return [...selected, ...rest];
}
